module.exports = __webpack_public_path__ + "img/sharf-logo-filled.15e3d4eb.svg";